import CollisionError from './collisionError';
import Error from './error';
import SuccessorWarning from './successorWarning';
import VersionWarning from './versionWarning';
import Warning from './warning';

/**
 * @class ProblemFactory
 */
export default class ProblemFactory {
    /**
     * @constructor
     * @param {ItemFactory} itemFactory
     * @param {CommandFactory} commandFactory
     * @param {History} history
     * @param {SelectionCollection} selection
     */
    constructor(itemFactory, commandFactory, history, selection) {
        this.itemFactory = itemFactory;
        this.commandFactory = commandFactory;
        this.history = history;
        this.selection = selection;
    }

    createError(type, message, icon, items) {
        return new Error(
            type,
            message,
            icon,
            items,
        );
    }

    createCollisionError(type, message, icon, items, collision) {
        return new CollisionError(
            type,
            message,
            icon,
            items,
            collision,
        );
    }

    createWarning(type, message, icon, items) {
        return new Warning(
            type,
            message,
            icon,
            items,
        );
    }

    createSuccessorWarning(type, message, icon, items) {
        return new SuccessorWarning(
            type,
            message,
            icon,
            items,
            this.itemFactory,
            this.commandFactory,
            this.history,
        );
    }

    createVersionWarning(type, message, icon, items) {
        return new VersionWarning(
            type,
            message,
            icon,
            items,
            this.selection,
        );
    }
}
